import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { CategoryService } from "src/app/services/category.service";
import { EntityService } from "src/app/services/entity.service";
import { ReportService } from "src/app/services/report.service";
import { SharedService } from "src/app/services/sharedService";
import { UserService } from "src/app/services/user.service";
import { MultiselectAutocompleteComponent } from "../../multiselect-autocomplete/multiselect-autocomplete.component";

@Component({
  selector: "app-users-search",
  templateUrl: "./search-users.component.html",
  styleUrls: ["./search-users.component.css"],
})
export class SearchUsersComponent implements OnInit, OnDestroy {
  userroles = [ 'ADMIN', 'MAYOR_TREASURER', 'CENTRAL_READER', 'FINANCIAL_MANAGER_ADMINISTRATOR', 'FINANCIAL_EDITOR',
    'CENTRAL_EDITOR', 'SECRETARY_ASSISTANT', 'AGENT_RECENSEUR', 'PROPERTIES_EDITOR', 'PROPERTIES_LECTEUR', 'FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_EDITOR', 'FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_LECTEUR', 'MAYOR_TREASURER_AND_PROPERTIES_LECTEUR',
  ];
  @ViewChild('userSelect', { static: false }) userSelect: MultiselectAutocompleteComponent;
  @ViewChild('municipalitySelect', { static: false }) municipalitySelect: MultiselectAutocompleteComponent;
  @ViewChild('recurringSelect', { static: false }) recurringSelect: MultiselectAutocompleteComponent;
  filterData = {
    category: null,
    municipality: null,
    recurring: null,
    users: null,
  };
  @Output() onFilter = new EventEmitter<any>();
  @Output() onReset = new EventEmitter<any>();
  @Input() extraFields : any;
  queryFilter = {};
  filterFields = ["category", "municipality", "user"];
  panelOpenState = true;
  municipalityChangeSubscription: any
  constructor(public categoryService: CategoryService, public entityService: EntityService,
    public reportService: ReportService, public userService: UserService, public sharedService: SharedService
  ) {
    this.filterFields.forEach((field) => {
      this.categoryService
        .getList(field)
        .subscribe((result) => {
          if (result) {
            this.filterData[field] = result.map((fld) => ({
              name: fld.name,
              id: fld.id,
            }));
            if (field === 'municipality'){
              setTimeout(()=>{
                if (localStorage.getItem('municipality')) {
                  if (localStorage.getItem('municipality') !== '-1') {
                    this.municipalitySelect.resetAll()
                    this.municipalitySelect.setSelectedData(this.filterData['municipality'].filter(elem => elem.id === localStorage.getItem('municipality')))
                  }
                  else { 
                    this.municipalitySelect.resetAll()
                  }
                }else{
                  this.municipalitySelect.resetAll()
                }
              }, 1000)
            }
          }
        });
    });
    reportService.getReportsList("?active=true&recurring=true").subscribe(rep => {
      if (rep && rep.reports){
        this.filterData.recurring = rep.reports.map(elem => ({id:elem._id, name: elem.name + ' ' + elem.year}))
      }
    })
    this.userService.getUsernames().subscribe(val => {
      this.filterData.users = val.map(user => ({ id: user.username.trim(), name: user.username }))
      .sort((a, b) => a.name.localeCompare(b.name));
    })
  }
  ngOnDestroy(): void {
    if (this.municipalityChangeSubscription) this.municipalityChangeSubscription.unsubscribe()
  }
  objectComparisonFunctionId = function (option, value): boolean {
    let sss = value ? option.key === value.key : false
    return sss;
  };
  selectChange = (event: any, field) => {
    this.queryFilter[field] = event.data.map(elem => elem.id)
    if (this.queryFilter[field].length===0){
      delete this.queryFilter[field]
    }
  };
  resetFilter() {
    this.queryFilter = {}
    this.userSelect.resetAll()
    this.municipalitySelect.resetAll()
    this.onReset.emit()
    
  }
  advancedSearch() {
    let selData = []
    selData = this.municipalitySelect.selectData.filter(el=> el.selected).map(el => el.item.id)
    if (localStorage.getItem('municipality')) {
      if (localStorage.getItem('municipality') == "-1") {
        delete this.queryFilter['municipality']
      } else {
        if (selData.length>0)
          this.queryFilter['municipality'] = selData
        else
        this.queryFilter['municipality'] = [localStorage.getItem('municipality')]
      }
    } else {
      if (this.municipalitySelect.selectData.length === 0)
        delete this.queryFilter['municipality']
    }
    this.onFilter.emit(this.queryFilter)
    this.panelOpenState = false
  }

  ngOnInit() {
    this.municipalityChangeSubscription = this.sharedService.changeMunicipalityEmitter.subscribe(val => {
      if (localStorage.getItem('municipality')) {
        if (localStorage.getItem('municipality') !== '-1') {
          this.municipalitySelect.resetAll()
          this.municipalitySelect.setSelectedData(this.filterData['municipality'].filter(elem => elem.id === localStorage.getItem('municipality')))
        }
        else { 
          this.municipalitySelect.resetAll()
        }
      }else{
        this.municipalitySelect.resetAll()
      }
    })
  }
}
